<div>
  <div #toolTip class="ol-tooltip hidden">{{ toolTipText }}</div>
  <div #measureToolTipCoord class="ol-tooltip ol-tooltip-measure">{{ measureTextCoord }}</div>
  <div #measureToolTip class="ol-tooltip ol-tooltip-measure">{{ measureText }}</div>
  <div #measureToolTipArea class="ol-tooltip ol-tooltip-measure">{{ measureTextArea }}</div>

  <ng-template #measureToolTipStaticTemplate>
    <div class="ol-tooltip ol-tooltip-static">{{ measureTextStatic }}</div>
  </ng-template>
  <ng-template #measureToolTipStaticAreaTemplate>
    <div class="ol-tooltip ol-tooltip-static"><sup>2</sup></div>
  </ng-template>

  <ng-container #viewContainer></ng-container>
</div>
